'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var _tslib = require('../_tslib-bcbe0269.js');
var core = require('@emotion/core');
var React = require('react');
var React__default = _interopDefault(React);
var IconWarningSolid = React__default.forwardRef(function (_a, ref) {
  var _b = _a.weight,
    props = _tslib.__rest(_a, ["weight"]);
  return core.jsx("svg", _tslib.__assign({
    viewBox: "0 0 24 24",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "])))
  }, props), core.jsx("path", {
    fill: "currentColor",
    d: "M23.119 20L13.772 2.15a2 2 0 0 0-3.543 0L.881 20a2 2 0 0 0 1.772 2.928h18.694A2 2 0 0 0 23.119 20zM11 8.423a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm1.05 11.51h-.028a1.528 1.528 0 0 1-1.522-1.47 1.475 1.475 0 0 1 1.421-1.529l.027-.001h.028A1.527 1.527 0 0 1 13.5 18.4c.032.814-.602 1.5-1.416 1.532l-.034.001z"
  }));
});
var templateObject_1;
exports.IconWarningSolid = IconWarningSolid;